import { atom } from 'jotai';
import { loadMe, type Me } from '../lib/me-cache';

/** Who am I and which tiles do I get (the kept copy when offline)? Suspends; boundary lives in _layout. */
export const meAtom = atom<Promise<Me>>(async () => loadMe());

/** Header gear toggles the IT/Dev settings view (single-page, no router). */
export const settingsOpenAtom = atom(false);
